import React,{useState} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { pathOr } from "ramda";
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { getCalculations } from '../../../../../../common/policyCalculation';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import {Typography,Link} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useStyles, { getMuiTheme } from "../../../DashletList/styles";
import { useTheme } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import {NoRecord,Alert } from "../../../../../../components";

function PolicyXirr({data,setValue,allTabFilter}) {
  
  const classes = useStyles();
  const theme = useTheme();
  const [responsive, setResponsive] = useState("standard");
  const [tableBodyHeight, setTableBodyHeight] = useState("100%");
  const [tableBodyMaxHeight, setTableBodyMaxHeight] = useState("");
  const [highliteRow, setHighliteRow] = useState(0);

  const headerLable = {'FundCode': 'Fund Code','MTD':'MTD','YTD':'YTD','1YTD':'1 Year','3YTD':'3 Years','5YTD':'5 Years','inc':'Since Inception'};
  let tableData = pathOr([], ['result', 'data',allTabFilter[6]['pname'] ], data);
  let tableDataFunds = pathOr([], ['result', 'data',allTabFilter[6]['pname'],'Funds' ], data);
  // console.log("tableDataFunds",data,allTabFilter[6]['pname']);
  const makeid=()=> {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    
    return text;
    }
    const columns = Object.values(headerLable); //["Name", "Company", "City", "State"];
    const parentRow = {};
    Object.keys(tableData).length > 0 && Object.keys(headerLable).map((col) => {
      if(col == 'FundCode'){
        parentRow[headerLable[col]]=allTabFilter[6]['pname'];
      }else{
        parentRow[headerLable[col]]=getCalculations('getValueInDecimalAndPercent', tableData[col]);
      }
    })

    const getFilteredData = () => tableDataFunds && Object.keys(tableDataFunds).map((item,itemKey) => {
      const row = {};
    Object.keys(headerLable).map((col) => {
      if(col == 'FundCode'){
        row[headerLable[col]]=item;
      }else{
        row[headerLable[col]]=getCalculations('getValueInDecimalAndPercent', tableDataFunds[item][col]);
      }
    })
      return row;
    });
    
  // const getFilteredDataLabels = () => {
  //   return [
  //      ...columns.filter((it) => it.name)
  //       .map((dl) => {
  //           return {
  //             ...dl,
  //             options: {
  //               filter: false,
  //               sort:false,
  //               customBodyRender: (value, tableMeta, updateValue) => {
  //                 console.log(tableMeta)
  //                return (
  //                 headerLable[value]
  //                 )
  //               }
  //             }
  //           }
  //         }
  //       )
  //       ]
  //     }
    const dataMui = Object.keys(parentRow).length > 0 ?[parentRow,...getFilteredData()] : [];
    // const dataMui = [parentRow,...getFilteredData()];

    const options = {
      responsive,
      tableBodyHeight,
      tableBodyMaxHeight,
      filter: false,
      download: false,
      serverSide: false,
      // count: parseInt(totalRecords),
      // rowsPerPage: rowsPerPage,
      // page,
      fixedHeader: true,
      fixedSelectColumn: true,
      search: false,
      print: false,
      viewColumns: false,
      selectableRowsHeader: false,
      // rowsPerPageOptions: [rowsPerPage],
      selectableRows: false,
      pagination:false,
      setRowProps: (row,rowKey) => { 
      
        if (highliteRow===rowKey) {
          return {
            style: { background: "#CCCCCC" }
          };
        }
      },
      textLabels: {
        body: {
          noMatch: <NoRecord 
          view = 'dashlet_no_data' 
          subpanel_module=''
          module=''
        />,
  
        },
      },
    };
    
    return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>



<MUIDataTable
  // title={"Employee List"}
  data={dataMui}
  columns={columns}
  options={options}
/>
             </MuiThemeProvider>
  );
}

export default React.memo(PolicyXirr)